/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import * as sc from './summary-panel-next.styles';
import { useNavigate } from 'react-router-dom';

const SummaryPanelNext = ({ columns, editUrl, trackEvent }) => {
  const navigate = useNavigate();
  const onClick = () => {
    trackEvent('pp_personal_details_verify_edit');
    const isEditUrlAString = typeof editUrl === 'string';
    if (editUrl) {
      if (isEditUrlAString) {
        return navigate(editUrl);
      }

      return editUrl();
    }

    return null;
  };

  return (
    <sc.Content>
      <sc.PanelHeader>
        <sc.Details>Verify Details</sc.Details>
        {editUrl && <sc.EditButton onClick={onClick}>Edit</sc.EditButton>}
      </sc.PanelHeader>
      <sc.Grid>
        {columns?.map((column, index) => (
          <sc.Col key={index}>
            {column?.map(content => (
              <div key={content.label}>
                <sc.TextBox>
                  <sc.Label>{content.label}</sc.Label>
                  <sc.Data>{content.data}</sc.Data>
                </sc.TextBox>
              </div>
            ))}
          </sc.Col>
        ))}
      </sc.Grid>
    </sc.Content>
  );
};

SummaryPanelNext.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        data: PropTypes.node
      })
    )
  ).isRequired,
  push: PropTypes.func.isRequired,
  editUrl: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.bool
  ])
};

SummaryPanelNext.defaultProps = {
  editUrl: null
};

export default SummaryPanelNext;
